import React, { useState } from 'react';
import { HeartIcon, ShareIcon, ZoomInIcon } from 'lucide-react';
import { SmartImage } from '../shared/SmartImage';
interface ProductImageGalleryProps {
  images: string[];
  productName: string;
  discount?: number;
  prescriptionNeeded?: boolean;
  compact?: boolean;
}
export function ProductImageGallery({
  images,
  productName,
  discount,
  prescriptionNeeded,
  compact = false
}: ProductImageGalleryProps) {
  const [selectedImage, setSelectedImage] = useState(0);
  return <div className={compact ? 'space-y-0' : 'space-y-4'} data-id="element-4983" data-mp="25k56x933w9mr">
      {/* Main Image - aspect-square */}
      <div className="group relative aspect-square overflow-hidden rounded-lg border border-brand-border bg-white" data-id="element-4984" data-mp="2jjwr5rk7um97">
        <SmartImage src={images[selectedImage]} alt={productName} aspectRatio="aspect-square" className="transition-transform duration-300 group-hover:scale-110" data-id="element-4985" data-mp="2elbqjr11y0k8" />
        {/* Discount Badge */}
        {discount && discount > 0 && <div className="absolute top-3 left-3 bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full z-10" data-id="element-4986" data-mp="tce2bt2zw78r">
            -{discount}%
          </div>}
        {!compact && <>
            {/* Action Buttons */}
            <div className="absolute right-3 top-3 z-10 flex flex-col gap-2" data-id="element-4987" data-mp="12b9a39lotpe6">
              <button type="button" className="rounded-full bg-white p-2 shadow-md transition-colors duration-150 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-4988" data-mp="1742flzozd1rb">
                <HeartIcon className="h-5 w-5 text-gray-700" data-id="element-4989" data-mp="1gzvo97zkwb3t" />
              </button>
              <button type="button" className="rounded-full bg-white p-2 shadow-md transition-colors duration-150 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-4990" data-mp="1m1l2ewi3l4w4">
                <ShareIcon className="h-5 w-5 text-gray-700" data-id="element-4991" data-mp="3nt7ul1dq75u6" />
              </button>
              <button type="button" className="rounded-full bg-white p-2 shadow-md transition-colors duration-150 hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-4992" data-mp="3rujcslu9sosc">
                <ZoomInIcon className="h-5 w-5 text-gray-700" data-id="element-4993" data-mp="u1884rz3t5gt" />
              </button>
            </div>
            <div className="pointer-events-none absolute bottom-3 left-1/2 -translate-x-1/2 rounded-full bg-black/60 px-3 py-1 text-xs text-white opacity-0 transition-opacity duration-150 group-hover:opacity-100" data-id="element-4994" data-mp="180haanqh5z1s">
              Hover to zoom
            </div>
          </>}
        {/* Prescription Badge */}
        {prescriptionNeeded && <div className="absolute bottom-3 left-3 bg-red-100 text-red-700 text-xs font-medium px-3 py-1 rounded-full border border-red-300" data-id="element-4995" data-mp="1rnp15l0t0wwr">
            Prescription needed
          </div>}
      </div>
      {!compact && <div className="flex gap-2 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Product images" data-id="element-4996" data-mp="20peu4vac43wn">
          {images.map((image, index) => <button key={index} type="button" onClick={() => setSelectedImage(index)} className={`h-14 w-14 shrink-0 overflow-hidden rounded-md border-2 transition-[border-color] duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand sm:h-16 sm:w-16 ${selectedImage === index ? 'border-brand' : 'border-gray-200 hover:border-gray-300'}`} aria-label={`View image ${index + 1} of ${images.length}`} data-id="element-4997" data-mp="2fakcl4b3w207" data-mpi={index}>
              <img src={image} alt={`${productName} thumbnail ${index + 1}`} className="h-full w-full bg-gray-50 object-cover" data-id="element-4998" data-mp="21bkpi138rv65" />
            </button>)}
        </div>}
    </div>;
}